import { createAsyncThunk } from '@reduxjs/toolkit';
import { signinStart, signinSuccess, signinFailure } from './signinSlice';
import axios from 'axios';
import { API, API_URL } from '../../config/api';




export const signin = createAsyncThunk(
  'signin/signin',
  async (userData, { dispatch, rejectWithValue }) => {
    dispatch(signinStart());
    try {
      const response = await axios.post(`${API_URL}${API.ADMIN.LOGIN}`, {
        email: userData.email,
        password: userData.password
      });
    
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      dispatch(signinSuccess(response.data));
      
      const permissions = user.permissions || [];
      const roleName = user.role?.name?.toLowerCase();

      // REDIRECTION INTELLIGENTE IMMÉDIATE
      if (roleName === "admin" || roleName === "administrateur") {
        window.location.href = '/rapports';
      } else if (permissions.includes('web:maternite:access')) {
        window.location.href = '/maternite';
      } else if (roleName === "comptable") {
        window.location.href = '/analytics/summary';
      } else if (user.role?.id === 3) {
        window.location.href = '/emergency';
      } else {
        window.location.href = '/rapports';
      }

    } catch (error) {
      dispatch(signinFailure(error.message));
      return rejectWithValue(error.message);
    }
  }
);
